import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import {
  Close as CloseIcon,
  Favorite as FavoriteIcon,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../../theme";

interface PersonaliseChoiceModalProps {
  open: boolean;
  onClose: () => void;
  onYes: () => void;
  onNo: () => void;
}

const PersonaliseChoiceModal: React.FC<PersonaliseChoiceModalProps> = ({
  open,
  onClose,
  onYes,
  onNo,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <Box
        sx={{
          p: 3,
          bgcolor: colors.primary[500],
          color: "white",
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <FavoriteIcon fontSize="large" />
          <Typography variant="h6" fontWeight="bold">
            Personalise Your Quote
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
          Would you like a more Personalised quotation with specific details
          about your beloved?
        </Typography>
      </Box>
      <DialogContent sx={{ p: 4 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={onYes}
          sx={{
            py: 1.5,
            mb: 2,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${colors.primary[500]} 0%, ${colors.primary[400]} 100%)`,
            color: "white",
            fontWeight: 600,
          }}
        >
          Yes, Personalise It
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={onNo}
          sx={{
            py: 1.5,
            borderRadius: 2,
            borderColor: "divider",
            color: "text.primary",
            fontWeight: 600,
          }}
        >
          No, Continue Without
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default PersonaliseChoiceModal;